<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import { buildMeta } from "~~/utils/meta-builder"
import { smoxyResearchData } from "~~/utils/research";
useHead(buildMeta({ key:'manifest',  follow: true }))
const i18n = useI18n()
const research = smoxyResearchData()

const nrFomat =  new Intl.NumberFormat(i18n.locale.value, {  maximumFractionDigits: 2, minimumFractionDigits: 0  })
const successRate = `${nrFomat.format(research.successRate)}`
const basedOnUserCount = nrFomat.format(research.users)
const date = new Intl.DateTimeFormat(i18n.locale.value, { year: 'numeric', month: 'long' }).format(research.ts)

</script>
<template>
  <div>
    <div class="w-full relative ">
        <div class="w-full h-full absolute -z-10 overflow-x-hidden">
            <div class="header w-full h-full">
              <svg class="absolute right-0" width="688" height="780" viewBox="0 0 688 780" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_f_14818_112467)">
                <circle cx="522.5" cy="257.5" r="278.5" fill="#FFA5A5" fill-opacity="0.79"/>
                </g>
                <defs>
                <filter id="filter0_f_14818_112467" x="0" y="-265" width="1045" height="1045" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                <feGaussianBlur stdDeviation="122" result="effect1_foregroundBlur_14818_112467"/>
                </filter>
                </defs>
              </svg>

               <svg class="absolute" width="377" height="565" viewBox="0 0 377 565" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_f_14818_112466)">
                <circle cx="9" cy="197" r="194" fill="#B5FBFF"/>
                </g>
                <defs>
                <filter id="filter0_f_14818_112466" x="-359" y="-171" width="736" height="736" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                <feGaussianBlur stdDeviation="87" result="effect1_foregroundBlur_14818_112466"/>
                </filter>
                </defs>
              </svg>

              <svg class="mx-auto" width="1131" height="612" viewBox="0 0 1131 612" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_f_14818_112468)">
                <circle cx="590" cy="22" r="206" fill="#A864FF"/>
                </g>
                <defs>
                <filter id="filter0_f_14818_112468" x="0" y="-568" width="1180" height="1180" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                <feGaussianBlur stdDeviation="192" result="effect1_foregroundBlur_14818_112468"/>
                </filter>
                </defs>
              </svg>

            </div>
        </div>
        <Header theme="light" />
    
        <div class="flex flex-col max-w-screen-lg gap-10 px-6 md:px-10 pt-10 mx-auto justify-center text-[#290B50] relative">
          
            <div class="flex flex-col flex-1 pb-20">
                <h1 class="text-6xl lg:text-7xl font-owners font-bold pb-6 pt-2 md:w-3/4" v-html="$t('manifest.headline')"></h1>
                <p class="text-black/75 text-2xl mt-10" v-html="$t('manifest.body')"></p>
            </div>

            <div class="grid grid-cols-3 relative">
              <h3 class="text-xl font-owners font-bold sticky top-5 h-10">{{$t('manifest.who.title')}}</h3>
              <p class="text-black/75 text-lg pb-6 pt-2 col-span-2" v-html="$t('manifest.who.body')"></p>
            </div>

            <div class="grid grid-cols-3 relative">
              <h3 class="text-xl font-owners font-bold sticky top-10 h-10">{{$t('manifest.what.title')}}</h3>
              <p class="text-black/75 text-lg pb-6 pt-2 col-span-2" v-html="$t('manifest.what.body')"></p>
            </div>

            <div class="grid grid-cols-3 relative">
              <h3 class="text-xl font-owners font-bold sticky top-10 h-10">{{$t('manifest.why.title')}}</h3>
              <p class="text-black/75 text-lg pb-6 pt-2 col-span-2" v-html="$t('manifest.why.body', {'quote': successRate})"></p>
            </div>
            <small class="mx-auto text-black/40">{{$t('manifest.note', {'user_count': basedOnUserCount, 'month_year':  date})}}</small>
            
        </div>
        <div class="bg-[#7E1EF8] w-full bg-gradient-radial from-violet-500 via-violet-600 to-violet-700 mt-10">
          <div class="max-w-screen-lg mx-auto grid md:grid-cols-3 px-20 md:px-0 pt-20 pb-36 gap-8">
              <div class="flex flex-col items-center text-center">
                  <img class="pb-6" src="@/assets/icon_puzzle_head.svg" alt="puzzle head icon" width="100" height="100" />
                  <h3 class="text-xl font-owners font-bold text-white">{{$t('manifest.vision.title')}}</h3>
                  <p class="text-xl text-white/70">{{$t('manifest.vision.body')}}</p>
              </div>
              <div class="flex flex-col items-center text-center">
                  <img class="pb-6" src="@/assets/icon_rocket.svg" alt="puzzle head icon" width="100" height="100" />
                  <h3 class="text-xl font-owners font-bold text-white">{{$t('manifest.mission.title')}}</h3>
                  <p class="text-xl text-white/70">{{$t('manifest.mission.body')}}</p>
              </div>
              <div class="flex flex-col items-center text-center">
                  <img class="pb-6" src="@/assets/icon_heart.svg" alt="puzzle head icon" width="100" height="100" />
                  <h3 class="text-xl font-owners font-bold text-white">{{$t('manifest.purpose.title')}}</h3>
                  <p class="text-xl text-white/70">{{$t('manifest.purpose.body')}}</p>
              </div>
          </div>
        </div>
        <div class="flex flex-col justify-center overflow-x-hidden">
          <p class="text-5xl md:leading-[5rem] md:text-[5.5rem] text-[#290B50] font-bold font-gothic mx-auto pt-32 text-center uppercase">
          You are<br>the<br>best project<br>you will<br>ever<br>work on
        </p>
        <img
          alt="Smoxy logo"
          src="@/assets/logo_transparent.svg"
          class="w-16 h-16 mb-2 mt-10 p-1 rounded-2xl bg-[#7E1EF8] mx-auto"
          />
        <p class="pb-48 mx-auto font-bold text-[#290B50]">Smoxy.app</p>
        </div>

      
    </div> 
    
 
     

    <Footer />
   
  </div>
</template>

